import { Suspense, lazy } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectIsOnlyOneActiveOrg } from "../../store/org/org.selector";
import {
  selectModalOpen,
  selectNotificationText,
  selectReferredOrgId,
  selectReferredSFNumber,
} from "../../store/timer/timer.selector";
import { removeCountryCode } from "../../utils/remove-country-code";
import { PendingAction } from "../app-layout/pending-action/pending-action.component";
import { IFrame } from "../iframe/iframe.component";
import { StyledModal, StyledPendingActionModal } from "./global-modals.styles";
import { TopUpModal } from "../add-topup-button/add-topup-modal.component";
import { useGetSummariesQuery, useUsersSyncQuery } from "../../store/api/api";
import { setModalOpen } from "../../store/timer/timer.reducer";
import { useLocation } from "react-router-dom";
import { AppRoutesObject } from "../../pages/app-routes.component";
import { PaymentDown } from "../payment-down/payment-down.component";
import { contactUs } from "../../utils/utils";

const EmailModal = lazy(() => import("../email-modal/email-modal.component"));

export const superfonePaymentsUrl = process.env.REACT_APP_SUPERFONE_PAYMENTS!;

export const GlobalModals = () => {
  const dispatch = useDispatch();
  const modalOpen = useSelector(selectModalOpen);
  const referredSFNumber = useSelector(selectReferredSFNumber);
  const orgId = useSelector(selectReferredOrgId);
  const notificationText = useSelector(selectNotificationText);
  const { data: sumariesResponse, isSuccess } = useGetSummariesQuery();
  const summaries = sumariesResponse || [];
  const location = useLocation();
  const getIsSubscribed = () => {
    const activeCount = summaries
      .map((summary) => (summary.is_active ? 1 : 0))
      .reduce((a: number, b: number) => a + b, 0);
    const trialActiveCount = summaries
      .map((summary) => (summary.is_trial_active ? 1 : 0))
      .reduce((a: number, b: number) => a + b, 0);
    if (isSuccess) {
      if (summaries.length === 1 && summaries[0].is_trial) {
        return false;
      }
      return activeCount + trialActiveCount > 0;
    } else {
      return true;
    }
  };

  const isSubscribed = getIsSubscribed();
  const onModalCancel = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(setModalOpen(false));
  };

  const onlyOneActiveOrg = useSelector(selectIsOnlyOneActiveOrg);

  const { data: usersSync } = useUsersSyncQuery();

  return (
    <>
      <StyledModal
        onCancel={onModalCancel}
        open={modalOpen && !!notificationText && !!(referredSFNumber || orgId)}
        footer={null}
        width="400px"
        centered
        title={notificationText}
        destroyOnClose
      >
        {false ? (
          <PaymentDown
            problem={
              referredSFNumber
                ? "Plan recharge is down"
                : "Plan purchase is down"
            }
            alternative="Please try paying via App or contact Whatsapp Support"
            onContact={() => {
              contactUs(
                "I am unable to make payment. Please help",
                referredSFNumber
                  ? "I want to renew my SF number"
                  : "I want to purchase new SF number"
              );
            }}
          />
        ) : (
          <IFrame
            title="SuperfonePaymentsFlow"
            src={`${superfonePaymentsUrl}?referred=true&referredSFNumber=${removeCountryCode(
              { phoneNumber: referredSFNumber }
            )}&referredOrgId=${orgId}${!isSubscribed ? "&discount=true" : ""}`}
            width="100%"
            height="100%"
          />
        )}
      </StyledModal>
      <StyledPendingActionModal
        className="pending-actions-modal"
        onCancel={() => {}}
        open={onlyOneActiveOrg && false}
        footer={null}
        width="700px"
        centered
        destroyOnClose
        closable={false}
        zIndex={5}
      >
        <PendingAction />
      </StyledPendingActionModal>
      {usersSync?.current_subscription?.subscription &&
      usersSync?.user?.tnc_accepted &&
      AppRoutesObject.GetStarted.url !== location.pathname ? (
        <Suspense>
          <EmailModal />
        </Suspense>
      ) : null}
      <TopUpModal />
    </>
  );
};
